import { createErrorSelector, createLoadingSelector } from "../../utils/reduxUtils";
import { PERFOMANCE_HIGHLIGHTS } from "../actions";

export const perfomanceHighlightsSelector = (period: string) => (state: any) => state.perfomanceHighlights[period];

export const perfomanceHighlightsLoadingSelector = createLoadingSelector([PERFOMANCE_HIGHLIGHTS]);
export const perfomanceHighlightsErrorSelector = createErrorSelector([PERFOMANCE_HIGHLIGHTS]);